import api from "@/services/api";

export default {
  namespaced: true, // Name of namespace exists here '@/store/namespaces'
  state: {
    bankingInstitutions: null,
  },
  getters: {
    getBankingInstitutions: (state) => {
      return state.bankingInstitutions;
    },
  },
  mutations: {
    setBankingInstitutions: (state, bankingInstitutions) => {
      state.bankingInstitutions = bankingInstitutions;
    },
  },
  actions: {
    async fetchBankingInstitutions({ commit, getters }, { qryParams }) {
      try {
        if (getters.getBankingInstitutions) {
          // If we already have banking institutions in state, we can skip the API call
          return;
        }

        const response = await api.get("/banking-institutions", {
          params: qryParams,
        });
        commit(
          "setBankingInstitutions",
          response.data.map((bi) => bi.item)
        );
      } catch (error) {
        console.error("Error fetching banking institutions:", error);
      }
    },
  },
};
